export const CLASS_NAMES = {
  wrapper:
    'w-full max-w-screen-lg 2xl:max-w-screen-2xl mx-auto mb-4 md:mb-16 bg-neutral-000 shadow-card',
  innerWrapper:
    'lg:p-5 flex flex-col md:flex-row items-start md:items-center justify-start',
  title: 'text-neutral-900 text-18-22-em block mb-1',
  subTitle: 'text-neutral-800 text-16-24',
  ctas: 'flex row flex-wrap items-center justify-start md:ml-14 mt-2 md:mt-0 gap-x-3 gap-y-2 md:gap-x-4',
};
